import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BASE_URL from '../../config';

const PasswordResetConfirmDe = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const token = searchParams.get('token');

  const handlePasswordResetConfirm = async () => {
    if (newPassword !== confirmPassword) {
      setSuccess(false);
      setMessage('Passwörter stimmen nicht überein.');
      return;
    }

    try {
      const response = await axios.post(`${BASE_URL}/api/password-reset-confirm/`, {
        token,
        password: newPassword,
      });

      setSuccess(true);
      setMessage(response.data.detail || 'Das Passwort wurde erfolgreich zurückgesetzt.');
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (error) {
      setSuccess(false);
      if (error.response && error.response.data) {
        const data = error.response.data;
        const msg = data.detail || data.error || data.message || JSON.stringify(data);
        setMessage(msg);
      } else if (error.request) {
        setMessage('Keine Antwort vom Server. Bitte versuche es erneut.');
      } else {
        setMessage(error.message);
      }
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2 className="auth-title">Passwort zurücksetzen</h2>
        <p className="auth-subtitle">Wähle ein neues Passwort für dein Konto</p>
        <div className="mb-3">
          <label className="auth-label">Neues Passwort</label>
          <input
            type="password"
            className="form-control auth-input"
            placeholder="••••••••"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="auth-label">Passwort bestätigen</label>
          <input
            type="password"
            className="form-control auth-input"
            placeholder="••••••••"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>
        <button className="auth-btn" onClick={handlePasswordResetConfirm}>
          Passwort zurücksetzen
        </button>
        {message && (
          <p className="auth-message" style={{ color: success ? '#2e7d32' : '#c62828' }}>
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default PasswordResetConfirmDe;
